import { SelectComponentsConfig } from 'react-select';

import * as Interfaces from '../interfaces';
import ClearIndicator from './ClearIndicator';
import Input from './Input';
import LoadingIndicator from './LoadingIndicator';
import Option from './Option';

/**
 * Extract a custom styling components for the <AutoComplete /> element
 * @param props list of supported props
 */
const Components: (
  props: Interfaces.SelectComponentProps
) => SelectComponentsConfig<Interfaces.OptionType> = props => ({
  LoadingIndicator,
  ClearIndicator: ClearIndicator(props),
  Option: Option(props),
  Input: Input
});

export default Components;
